import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title:
    "Automatic case creation and \nassignment, along with \nproviding recommended \nresolutions for the agent",
  subtitle: "Network operations demo",
  text: "Achieving accuracy on the first attempt, reducing \nresolution time, and cutting OpEx costs.",
  label: {
    iconPath: "start.png",
    text: "Case Management - Automatic case creation, Notification management",
  },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_212"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_210"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 8_R1.mp4",
  pageNumber: "ILO_211",
};

export default DATA_NO_DEMO_ILO2;
